import React, { useState } from 'react';
import './css/maintenance.css';
import Seo from './Seo';

const Maintenance = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    serviceType: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log(formData);
    // You can use the emailjs library to send the form data via email
  };

  return (
    <div className="maintenance-container">
      <Seo
        title="Solar Panel Maintenance & Repair in San Diego | PV Solar"
        description="Professional solar system maintenance, monitoring, and repair in San Diego. Keep your panels and batteries at peak efficiency with PV Solar."
        path="/maintenance"
      />
      <div className="maintenance-content">
        <h1>Solar System Maintenance</h1>
        <p>Keep your solar system running at peak efficiency with our professional maintenance services.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="serviceType">Service Type</label>
            <select
              id="serviceType"
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
              required
            >
              <option value="">Select Service</option>
              <option value="panel-cleaning">Panel Cleaning</option>
              <option value="inverter-maintenance">Inverter Maintenance</option>
              <option value="system-inspection">System Inspection</option>
              <option value="system-monitoring">System Monitoring/Verification</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Maintenance;